import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  where,
  documentId,
  getDocs,
  query,
  collection,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase-config";
import { async } from "@firebase/util";

export const Generator = () => {
  const [sentences, setSentences] = useState([]);
  const [sentencesResult, setSentencesResult] = useState([]);
  const [selectedLang, setSelectedLang] = useState({
    generateLettersLang: "sv",
    selectedSentencesLang: "SwedishSentences",
  });
  // const [selectedSentencesLang, setselectedSentencesLang] = useState("EnglishLetters");
  const [errorMsg, setErrorMsg] = useState("");
  const disableBtn = useRef();
  // const selectedSentencesLang = useRef()
  const langOptions = [
    {
      id: "sv",
      name: "Swedish Sentences",
      obj: {
        generateLettersLang: "SV",
        selectedSentencesLang: "SwedishSentences",
      },
    },
    {
      id: "en",
      name: "English Sentences",
      obj: {
        generateLettersLang: "EN",
        selectedSentencesLang: "EnglishSentences",
      },
    },
    {
      id: "da",
      name: "Danish Sentences",
      obj: {
        generateLettersLang: "DA",
        selectedSentencesLang: "DanishSentences",
      },
    },
    {
      id: "fi",
      name: "Finnish Sentences",
      obj: {
        generateLettersLang: "FI",
        selectedSentencesLang: "FinnishSentences",
      },
    },
    {
      id: "de",
      name: "German Sentences",
      obj: {
        generateLettersLang: "DE",
        selectedSentencesLang: "GermanSentences",
      },
    },
    {
      id: "no",
      name: "Norwegian Sentences",
      obj: {
        generateLettersLang: "NO",
        selectedSentencesLang: "NorwegianSentences",
      },
    },
    {
      id: "et",
      name: "Estonian Sentences",
      obj: {
        generateLettersLang: "ET",
        selectedSentencesLang: "EstonianSentences",
      },
    },
    {
      id: "it",
      name: "Italian Sentences",
      obj: {
        generateLettersLang: "IT",
        selectedSentencesLang: "ItalianSentences",
      },
    },
    {
      id: "fr",
      name: "French Sentences",
      obj: {
        generateLettersLang: "FR",
        selectedSentencesLang: "FrenchSentences",
      },
    },
  ];
  useEffect(() => {
    getSentences();
  }, [selectedLang]);

  // useEffect(() => {
  //   console.log(sentences.forEach((e, i) => console.log(i, e, e.split(' ').length)))
  // }, [sentences]);

  function getRandom(arr, n) {
    let result = new Array(n),
      len = arr.length,
      taken = new Array(len);
    if (n > len) {
      setErrorMsg("More elements taken than available. Please Try Again..");
      throw new RangeError("getRandom: more elements taken than available");
    }
    while (n--) {
      let x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
    }

    return result;
  }

  // const sentencesGen = (e) => {
  //   e.preventDefault();
  //   setErrorMsg("");
  //   let randomSentences = [];
  //   for (let i = 0; i < sentences.length; i++) {
  //     let check;
  //     const result = getRandom(sentences, 3);
  //     // console.log(result)
  //     result.forEach((element, index) => {
  //       if (index === 1) {
  //         check = false;
  //       }
  //       //  randomnum1 = (Math.random() * (3 - 2.8) + 2.8).toFixed(3)
  //       //  randomnum2 = (Math.random() * (5.9 - 2.8) + 2.8).toFixed(3)
  //       // randomnum3 = (Math.random() * (4.8 - 3.5) + 3.5).toFixed(3)
  //     });
  //     //**************************************************** */

  //     if (!check) {
  //       let positions = result.map((w) => w.split(" ").length);
  //       // console.log(result, positions)
  //       positions.pop();
  //       const correctPosition = positions.reduce(
  //         (accumulator, currentValue, currentIndex) => {
  //           const sumPos = Number(accumulator) + parseInt(currentValue);
  //           return [...accumulator, sumPos];
  //         },
  //         []
  //       );
  //       console.log(result);
  //       randomSentences.push({
  //         sentence: result.join(" "),
  //         correctPosition: correctPosition,
  //         correctAnswerTimes: [],
  //         wrongeAnswerTimes: [],
  //       });
  //     }
  //   }
  //   randomSentences.forEach((item, i) => {
  //     item.id = i;
  //   });
  //   // console.log(randomSentences);
  //   setSentencesResult(randomSentences);
  // };

  const sentencesGen = (e) => {
    e.preventDefault();
    setErrorMsg("");
    let randomSentences = [];

    // Keep track of how many times each sentence has been used in each position
    const usageCount = sentences.reduce((acc, sentence) => {
      acc[sentence] = { first: 0, middle: 0, last: 0 };
      return acc;
    }, {});

    // Helper function to get available sentences for a specific position
    const getAvailableSentences = (position) => {
      return sentences.filter((sentence) => {
        if (position === 0 && usageCount[sentence].first < 1) return true;
        if (position === 1 && usageCount[sentence].middle < 1) return true;
        if (position === 2 && usageCount[sentence].last < 1) return true;
        return false;
      });
    };

    // Generate chains until we can't create any more valid combinations
    while (true) {
      const firstSentences = getAvailableSentences(0);
      const middleSentences = getAvailableSentences(1);
      const lastSentences = getAvailableSentences(2);

      // Check if we can create a new chain
      if (
        firstSentences.length === 0 ||
        middleSentences.length === 0 ||
        lastSentences.length === 0
      ) {
        break;
      }

      // Randomly select sentences for each position
      const first =
        firstSentences[Math.floor(Math.random() * firstSentences.length)];
      const middle =
        middleSentences[Math.floor(Math.random() * middleSentences.length)];
      const last =
        lastSentences[Math.floor(Math.random() * lastSentences.length)];

      // Update usage count
      usageCount[first].first++;
      usageCount[middle].middle++;
      usageCount[last].last++;

      // Create the chain
      const result = [first, middle, last];
      let positions = result.map((w) => w.split(" ").length);
      positions.pop();
      const correctPosition = positions.reduce((accumulator, currentValue) => {
        const sumPos =
          accumulator.length === 0
            ? parseInt(currentValue)
            : Number(accumulator[accumulator.length - 1]) +
              parseInt(currentValue);
        return [...accumulator, sumPos];
      }, []);

      randomSentences.push({
        sentence: result.join(" "),
        correctPosition: correctPosition,
        correctAnswerTimes: [],
        wrongeAnswerTimes: [],
        id: randomSentences.length,
      });
    }
console.log(randomSentences);
    setSentencesResult(randomSentences);
  };

  // const getSentences = useCallback(async () => {
  //   let querySentences;
  //   querySentences = query(collection(db, selectedLang.selectedSentencesLang));

  //   const sentencesDocs = await getDocs(querySentences);

  //   let wDocs = sentencesDocs.docs;
  //   wDocs.map((doc) => {
  //     // console.log(doc.data().sentences);
  //     return setSentences(doc.data().sentences);
  //   });
  // }, [selectedLang]);

  const getSentences = useCallback(async () => {
  const LOCO_API_KEY = 'iXr3tH_JosqZRS9DDlgQfaswC3hBVcbW';

  try {
    const localeCode = selectedLang.generateLettersLang.toLowerCase();
    const response = await fetch(`/api/loco/export/locale/${localeCode}.json?key=${LOCO_API_KEY}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);
    // Transform the response data into an array of sentences
    const sentencesArray = Object.values(data)
      .filter(item => typeof item === 'string' && item.trim().length > 0)
      .map(item => item.trimEnd());
    setSentences(sentencesArray);

  } catch (error) {
    console.error('Error fetching sentences from Loco:', error);
    setErrorMsg('Failed to load sentences. Please try again.');
  }
}, [selectedLang]);
  
  useEffect(() => {
    checkIfSentencesExist();
  }, []);

  useEffect(() => {
    for (let i of sentences) {
      let words = i.split(" ");
      for (let w of words) {
        if (w.length > 15) console.log(w.length);
      }
    }
  }, [sentences]);

  const checkIfSentencesExist = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "SentencesChain"));
      let allDocs = [];
      querySnapshot.forEach((doc) => {
        allDocs.push({ ...doc.data(), id: doc.id });
      });
    } catch (err) {
      console.log(err);
    }
  };

  const CLOUD_RUN_BASE_URL = process.env.REACT_APP_CLOUD_RUN_URL || "";

  const addToDB = useCallback(async () => {
    if (!sentencesResult.length) {
      setErrorMsg("No sentences generated yet. Generate sentences first.");
      return;
    }
    try {
      const response = await fetch(
        `${CLOUD_RUN_BASE_URL}/TrainingData/chain?type=sentences`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
          items: sentencesResult.map((item) => ({
            sentenceId: item.id,
            language: selectedLang.generateLettersLang.toLowerCase(),
            value: item.sentence,
            correctPosition1: item.correctPosition[0],
            correctPosition2: item.correctPosition[1],
            correctAnswerTimes: item.correctAnswerTimes,
            wrongAnswerTimes: item.wrongeAnswerTimes,
          })),
        }),
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Chain inserted:", data);
      alert(`Success: ${data.message} (${data.insertedCount} items)`);
    } catch (error) {
      console.error("Error submitting chain to DB:", error);
      setErrorMsg("Failed to submit chain to database. Check console for details.");
    }
  }, [sentencesResult, selectedLang, CLOUD_RUN_BASE_URL]);

  const handleChange = (e) => {
    const langId = e.target.value;
    const lang = langOptions.find((u) => u.id === langId);
    console.log(langId, lang);
    setSelectedLang(lang.obj);
  };

  return (
    <div className="container">
      <button className="" ref={disableBtn} onClick={addToDB}>
        Push to DB
      </button>
      <form className="op-form" onSubmit={sentencesGen}>
        <label>
          <select onChange={handleChange}>
            {langOptions.map((option, index) => (
              <option key={index} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        </label>
        <input type="submit" className="submitbtn" value="Generate sentences" />
      </form>
      {errorMsg ? (
        <h2>{errorMsg}</h2>
      ) : (
        <ol>
          {sentencesResult.map((elem, key) => {
            return (
              <li key={key}>
                {elem.sentence}
                {"    "}
                <span>{`[${elem.correctPosition.toString()}]`}</span>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};
